
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetobhimashankarround() {



    const cardData =
    {
        keyword: 'Pune To Bhimashankar Round Trip',
        heading: 'Mauli Cabs: Pune To Bhimashankar Round Trip',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Bhimashankar round trip services, ensuring a smooth and spiritual journey to one of the twelve Jyotirlingas. Whether you are visiting for a pilgrimage, a family outing, or a peaceful retreat, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enriching experience on your round trip from Pune to Bhimashankar.',

        top: 'Top Places to Visit in Bhimashankar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "The Bhimashankar Temple is one of the twelve Jyotirlingas and is dedicated to Lord Shiva. It is situated in the Sahyadri hills and is a popular pilgrimage site for devotees of Lord Shiva."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "The Bhimashankar Wildlife Sanctuary, located in the surrounding area, is home to a variety of flora and fauna. It is a great place for nature lovers and those interested in trekking."
    },
    {
        "title": "Kedareshwar Temple",
        "description": "This ancient temple, located near the Bhimashankar Temple, is dedicated to Lord Shiva. It is famous for its tranquil surroundings and its serene atmosphere, perfect for spiritual seekers."
    },
    {
        "title": "Gupta Bhimashankar",
        "description": "Gupta Bhimashankar is a hidden temple located near the main Bhimashankar Temple. It is believed to be the place where Lord Shiva's image was originally discovered."
    },
    {
        "title": "Sahyadri Mountain Range",
        "description": "The Bhimashankar region is part of the Sahyadri mountain range, offering beautiful trekking routes and scenic views of the Western Ghats. It is ideal for adventure enthusiasts and nature lovers."
    },
    {
        "title": "Hanuman Lake",
        "description": "Located near Bhimashankar Temple, Hanuman Lake is a serene and peaceful spot. The lake is surrounded by lush greenery, making it a great place to relax and enjoy nature."
    },
    {
        "title": "Nandi Mandir",
        "description": "The Nandi Mandir is located on the way to the Bhimashankar Temple and is dedicated to Lord Nandi, the vehicle of Lord Shiva. The temple is small but holds great significance in the area."
    },
    {
        "title": "Trekking Trails",
        "description": "Bhimashankar is known for its beautiful trekking trails. The trek to the Bhimashankar Temple offers stunning views of the surrounding hills and forests, making it a popular activity for trekkers."
    },
    {
        "title": "Matheran Viewpoint",
        "description": "Matheran Viewpoint, located nearby, offers panoramic views of the surrounding mountains and valleys. It's a perfect spot to witness breathtaking sunsets."
    },
    {
        "title": "Panchgani",
        "description": "Panchgani, located not far from Bhimashankar, is a hill station known for its picturesque landscapes, colonial-era architecture, and pleasant weather. It’s a great place to explore for nature enthusiasts."
    }
],

"services": [
    {
        "name": "Pune to Bhimashankar Round Trip Cab Service",
        "description": "Mauli Cabs offers reliable round-trip cab services from Pune to Bhimashankar, making your pilgrimage journey comfortable and hassle-free. Enjoy a safe and serene ride to this sacred temple."
    },
    {
        "name": "Book Pune to Bhimashankar Taxi",
        "description": "Book your taxi from Pune to Bhimashankar with Mauli Cabs. We offer seamless booking, ensuring a smooth and peaceful journey to the Bhimashankar temple."
    },
    {
        "name": "Affordable Pune to Bhimashankar Round Trip",
        "description": "Mauli Cabs offers affordable round-trip taxi services from Pune to Bhimashankar. Enjoy a budget-friendly pilgrimage trip with reliable and comfortable services."
    },
    {
        "name": "Private Taxi for Bhimashankar from Pune",
        "description": "Travel privately to Bhimashankar from Pune with Mauli Cabs. We provide personalized services to ensure a calm and comfortable journey to this sacred temple."
    },
    {
        "name": "Bhimashankar Pilgrimage by Cab from Pune",
        "description": "Mauli Cabs offers convenient and comfortable cab services for your Bhimashankar pilgrimage. Visit the temple with peace of mind and experienced drivers guiding your journey."
    },
    {
        "name": "Pune to Bhimashankar One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip taxi services from Pune to Bhimashankar, allowing flexibility based on your travel preferences and schedule."
    },
    {
        "name": "Comfortable Taxi Ride to Bhimashankar",
        "description": "Enjoy a comfortable and peaceful taxi ride to Bhimashankar from Pune with Mauli Cabs. Our well-maintained vehicles ensure a smooth journey to the temple."
    },
    {
        "name": "Group Travel to Bhimashankar",
        "description": "Travel with a group to Bhimashankar from Pune in comfort with Mauli Cabs. We offer spacious vehicles to ensure your group journey is enjoyable and hassle-free."
    },
    {
        "name": "Luxury Taxi for Bhimashankar Trip",
        "description": "Travel in luxury to Bhimashankar with Mauli Cabs' premium taxi services. Experience high-end comfort and style during your pilgrimage trip."
    },
    {
        "name": "Bhimashankar Temple Tour by Taxi",
        "description": "Mauli Cabs offers taxi services for a complete Bhimashankar temple tour. Visit the temple and explore nearby spots with ease, guided by our professional drivers."
    }
],

"tableData": [
    ["Pune to Bhimashankar Round Trip Cab Service", "Book Pune to Bhimashankar Taxi"],
    ["Affordable Pune to Bhimashankar Round Trip", "Private Taxi for Bhimashankar from Pune"],
    ["Bhimashankar Pilgrimage by Cab from Pune", "Pune to Bhimashankar One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Bhimashankar", "Group Travel to Bhimashankar"],
    ["Luxury Taxi for Bhimashankar Trip", "Bhimashankar Temple Tour by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Bhimashankar Round Trip. Our professional drivers ensure that you are picked up and dropped off on time, so you can fully enjoy your trip without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Bhimashankar Round Trip, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All our vehicles are air-conditioned, spacious, and well-maintained, ensuring a smooth and pleasant ride for the entire journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are well-acquainted with the Pune to Bhimashankar route. They ensure a smooth, safe, and timely journey, taking care of the best routes and traffic conditions for a hassle-free trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable pricing for your Pune to Bhimashankar Round Trip with no hidden charges. We believe in transparent pricing, ensuring that you get the best value for your trip without any surprise fees."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable ride to Bhimashankar and back."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Bhimashankar Round Trip. Whether you want to start early in the morning or return late at night, our customer service team is available anytime to assist you with your booking."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Bhimashankar Round Trip with Mauli Cabs is simple and hassle-free. You can book online via our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Bhimashankar Round Trip. Whether you’re visiting for a spiritual journey or a scenic getaway, we can tailor the trip to meet your preferences and needs."
    }
]
















    }



    const faqData = [
        {
            question: 'How do I book a round trip from Pune to Bhimashankar with Mauli Cabs?',
            answer: 'Booking a round trip from Pune to Bhimashankar is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location, Bhimashankar as your destination, and select a vehicle. Alternatively, you can call our customer support team for booking assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Bhimashankar round trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your round trip, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose a vehicle based on your comfort and group size.',
        },
        {
            question: 'Is the fare for the Pune to Bhimashankar round trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, so there are no hidden costs. The total fare will be provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the round trip from Pune to Bhimashankar take?',
            answer: 'The round trip from Pune to Bhimashankar typically takes around 6 to 8 hours, depending on traffic and road conditions. Our drivers ensure a smooth and timely journey, making sure you have enough time to visit the temple.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Bhimashankar route?',
            answer: 'Yes, all Mauli Cabs drivers are experienced with the Pune to Bhimashankar route. They are familiar with the best routes to ensure a comfortable, safe, and timely journey to the temple.',
        },
        {
            question: 'Can I make stops for sightseeing on the way to Bhimashankar?',
            answer: 'Yes, you can customize your round trip by making stops at sightseeing spots or taking breaks along the way. Our drivers can assist you in exploring nearby attractions or simply provide time for relaxation.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We ensure a comfortable, smooth, and enjoyable ride for your trip to Bhimashankar.',
        },
        {
            question: 'Can I cancel or modify my round trip booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Bhimashankar round trip?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a range of vehicle options, and professional drivers. We ensure that your round trip to Bhimashankar is comfortable, safe, and convenient.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Kulkarni",
            position: "Devotee",
            text: "Our round trip to Bhimashankar was amazing! The driver was professional and knew the best routes. The vehicle was clean and comfortable, and we had a peaceful visit to the temple. Highly recommend Mauli Cabs for temple trips!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Meera Joshi",
            position: "Spiritual Traveler",
            text: "The trip to Bhimashankar was one of the best experiences. Mauli Cabs provided a comfortable, air-conditioned cab, and the driver was courteous and familiar with the area. It was a stress-free, pleasant trip. Would definitely use their services again!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Bhimashankar Round Trip by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable round-trip cab services from Pune to Bhimashankar. Choose from private, luxury, or group taxis for your pilgrimage journey. Enjoy a smooth, hassle-free ride to Bhimashankar Temple with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "3800"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Bhimashankar Round Trip | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Bhimashankar round trip with Mauli Cabs. Affordable and reliable taxi options available for one-way or round-trip travel. Comfortable private, luxury, or group travel for your pilgrimage, with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Bhimashankar round trip cab service, Book Pune to Bhimashankar taxi, Affordable Pune to Bhimashankar round trip, Private taxi for Bhimashankar from Pune, Bhimashankar pilgrimage by cab from Pune, Pune to Bhimashankar one-way or round trip, Comfortable taxi ride to Bhimashankar, Group travel to Bhimashankar, Luxury taxi for Bhimashankar trip, Bhimashankar temple tour by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankarround;